<!--
    描述： 企业提现账户审核.vue
    创建时间： 2022-03-30 10:30:33
    作者： Wang Shuai
    邮箱： 591372242@qq.com
	修改人： 钱磊
	修改时间：2022-4-28 09:25:04
-->
<template>
	<div class="audit-account-main">
		<h4 class="account-header">温馨提示：企业开通安招采投标人业务设置支付功能，未填写对公账户，使用通联方提供的默认的固定账户。以下信息为该企业在办理企业资金提现账户时提交的对公账户信息</h4>
		<div class="account-form">
			<el-row :gutter="20">
				<el-col :span="12">企业名称：{{ baseForm.sname }}</el-col>
				<el-col :span="12">统一社会信用代码：{{ baseForm.creditCode }}</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">法人代表姓名：{{ baseForm.legaler }}</el-col>
				<el-col :span="12">法人代表手机号：{{ baseForm.legalPhone }}</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">法人代表证件类型：{{ baseForm.cardType }}</el-col>
				<el-col :span="12">法人代表证件号：{{ baseForm.idCard }}</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">申请人：{{ baseForm.createUser }}</el-col>
				<!-- <el-col :span="12">申请人手机号：{{ baseForm.sname }}</el-col> -->
			</el-row>
			<el-row :gutter="20">
				<el-col :span="22">通联支付会员号 (bizuserId)：{{ baseForm.bizUserid }}</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="color-red">变更前：</el-col>
			</el-row>
			<el-row :gutter="20" class="change-block">
				<el-col :span="12">开户银行：招商银行</el-col>
				<el-col :span="12">对公账户：88888888</el-col>
				<el-col :span="12">开户行支行名称：招商银行股份有限公司合肥分行</el-col>
				<el-col :span="12">支付行行号：308361030017</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="color-red">变更后：</el-col>
			</el-row>
			<el-row :gutter="20" class="change-block">
				<el-col :span="12">开户银行：{{ baseForm.bank }}</el-col>
				<el-col :span="12">对公账户：{{ baseForm.account }}</el-col>
				<el-col :span="12">开户行支行名称：{{ baseForm.branchBank }}</el-col>
				<el-col :span="12">支付行行号：{{ baseForm.payNo }}</el-col>
			</el-row>

			<p class="color-red">以上信息审核流程如下，审核通过前，请勾选确认下来事项已经完成：</p>
			<p><el-checkbox class="mr10" v-model="checkConfirm.check1" :disabled="isDisabled"></el-checkbox>1<i class="color-red">*</i>. 线下与投标客户确认对公账户信息填写是否正确，如客户填写不正确，可在审核意见栏注明原因后驳回。</p>
			<p><el-checkbox class="mr10" v-model="checkConfirm.check2" :disabled="isDisabled"></el-checkbox>2<i class="color-red">*</i>. 联系通联更改该企业对公账户信息，并提供纸质盖章文件（拍照发送通联即可）。
				<a href="javascript:;" class="color-blue" @click="FileDownload">【通联企业对公账户变更申请表】点击下载</a>
			</p>
			<p><el-checkbox class="mr10" v-model="checkConfirm.check3" :disabled="isDisabled"></el-checkbox>3<i class="color-red">*</i>. 再确认通联修改完成该企业对公账户信息后，审核通过即可</p>
		</div>

		<el-form ref="auditForm" label-width="100px" :model="auditForm" class="mt20" size="small" :class="{'show-form': isDisabled}">
			<el-row>
				<el-col :span="20">
					<el-form-item label="审核结果：" :rules="[{ required: true, message: '不能为空...' }]" prop="status">
						<el-select v-model="auditForm.status"
								   v-if="mode !== 'view'"
								   placeholder="请选择..."
								   :disabled="isDisabled">
							<el-option label="审核通过" :value="1"></el-option>
							<el-option label="驳回" :value="2"></el-option>
						</el-select>
						<span v-else>{{ infoObj.status === 1 ? '审核通过' : '驳回' }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="20">
					<el-form-item label="审核意见：" :rules="[{ required: true, message: '不能为空...', trigger: 'blur' }]" prop="remark">
						<el-input type="textarea"
								  v-if="mode !== 'view'"
								  v-model="auditForm.remark"
								  placeholder="请输入..."
								  show-word-limit
								  maxlength="200"
								  :autosize="{ minRows: 4 }"></el-input>
						<span v-else>{{ infoObj.remark }}</span>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
// api
import { auditAccount, getRecordDetail } from 'api/modules/audit'
export default {
	props: {
		// 主键id
		rowId: {
			type: String,
			default: '',
		},
		// 当前模式
		mode: {
			type: String,
			default: 'audit',
		},
		// 回显的审核数据
		infoObj: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
    data() {
        return {
        	baseForm: {},
        	checkConfirm: {
        		check1: false,
        		check2: false,
        		check3: false
        	},
        	auditForm: {

        	}
        }
    },
    created() {
    	this.getAllInfo()
    	if (this.mode === 'view') {
    		this.checkConfirm.check1 = true
    		this.checkConfirm.check2 = true
    		this.checkConfirm.check3 = true
    	}
    },
    methods: {
    	// 获取公司信息
		getAllInfo() {
			getRecordDetail({ recordId: this.rowId, id: this.rowId })
				.then((res) => {
					this.baseForm = this.$utils.clone(res.data, true)
				})
				.catch(err => {})
		},

		// 下载文件
		FileDownload() {
			let origin = window.location.origin
			let pathname = window.location.pathname
			// let url = origin + pathname + '对公账户变更单.doc'
			// window.open(url, 'target')
			window.location.href = origin + pathname + '对公账户变更单.doc'
		},

		// 提交校验
		async onSubmit() {
			let status = false
			let checkStatus = this.checkConfirm.check1 && this.checkConfirm.check2 && this.checkConfirm.check3
			let _error = this.auditForm.status === 2
			if (checkStatus || _error) {
				this.$refs.auditForm.validate(valid => {
					if (!valid) {
						this.$message.warning('请完善审核结果及意见！')
					}
					status = valid
				})
			} else {
				this.$message.warning('请确认勾选上一些主要事项')
				status = false
			}

			return status
		}
    },
    computed: {
    	// 是否可编辑
    	isDisabled() {
    		return this.mode === 'view'
    	}
    }
}
</script>

<style lang="less" scoped>
.audit-account-main {
	.account-header {
		color: #2671cc;
	    background-color: #f1f1f1;
	    padding: 10px;
	    margin-bottom: 10px;
	}

	.account-form {
		line-height: 30px;
	}

	.color-blue {
		color: #2671cc;
		text-decoration: underline;
	}

	.color-red {
		color: red;
	}

	.change-block {
		background-color: #f1f1f1;
		margin-bottom: 10px;
		padding: 10px 0;
	}
}
</style>
